/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1TagTagidLangsId202,
  DeleteApiV1TagTagidLangsId401,
  DeleteApiV1TagTagidLangsId404,
  DeleteApiV1TagTagidLangsId500,
  DeleteApiV1TagTagidLangsIdMutationResponse,
  DeleteApiV1TagTagidLangsIdPathParams,
} from "../../types/tagIdiomasController/DeleteApiV1TagTagidLangsId.ts";

export const deleteApiV1TagTagidLangsIdPathParamsSchema = z.object({
  tagId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1TagTagidLangsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1TagTagidLangsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagTagidLangsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1TagTagidLangsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagTagidLangsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1TagTagidLangsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagTagidLangsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1TagTagidLangsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1TagTagidLangsId500>;

export const deleteApiV1TagTagidLangsIdMutationResponseSchema = z.lazy(
  () => deleteApiV1TagTagidLangsId202Schema,
) as unknown as ToZod<DeleteApiV1TagTagidLangsIdMutationResponse>;
